import { Trans } from 'react-i18next';

import { Button, ButtonVariant, ModalCloseButton, ModalWidth, StrongText, StyledFlex } from '@dreryk/react-components';
import { TranslatableText } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { NfzMfaForm } from './NfzMfaForm';
import { NfzMfaFormBean, NfzMfaTotpErrorSetter } from './NfzMfaForm.types';
import { StyledNfzMfaModal } from './NfzMfaModal.styled';

type NfzMfaModalProps = {
   readonly onClose: VoidFunction;
   readonly onLogin: (mfaTotp: string, setError: NfzMfaTotpErrorSetter) => Promise<void>;
   readonly blockingOperationLabel?: TranslatableText;
};

export const NfzMfaModal = (props: NfzMfaModalProps): JSX.Element => {
   return (
      <StyledNfzMfaModal
         testId={'nfzMfaLogin'}
         title={translationKeys.mfaModal.title}
         width={ModalWidth.NORMAL}
         visible
         animateVisibility
      >
         <StyledFlex direction={'column'} gap={16}>
            <div>
               <Trans
                  i18nKey={translationKeys.mfaModal.subtitle}
                  components={{ bold: <StrongText testId={'nfzServices'} /> }}
               />
            </div>
            <NfzMfaForm>
               {({ handleSubmit, setMfaTotpError }) => (
                  <Button
                     testId={'nfzMfaLogin'}
                     label={translationKeys.mfaModal.loginButton}
                     variant={ButtonVariant.PRIMARY}
                     blockingOperation={props.blockingOperationLabel ?? true}
                     onClick={handleSubmit(async (formBean: NfzMfaFormBean) => {
                        await props.onLogin(formBean.mfaTotp!, setMfaTotpError);
                     })}
                     nowrap
                  />
               )}
            </NfzMfaForm>
            <ModalCloseButton onClick={props.onClose} />
         </StyledFlex>
      </StyledNfzMfaModal>
   );
};
